module.exports = __webpack_public_path__ + "img/history10.f8b090ae.jpg";